import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-entry-dialog',
  templateUrl: './delete-entry-dialog.component.html',
  styleUrls: ['./delete-entry-dialog.component.css'],
})
export class DeleteEntryDialogComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
